import { ReactComponent as OutlineInfoCircle16 } from "assets/svg/outline-info-circle-16.svg";
import messages from "messages";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import styles from "../../SessionSidesheet.module.scss";

interface AdminNoteSessionDetilsSectionProps {
  adminNote: string;
}

const AdminNoteSessionDetilsSection = ({
  adminNote,
}: AdminNoteSessionDetilsSectionProps) => (
  <div className={styles["section"]}>
    <div className={styles["section__title"]}>
      {messages.adminNote}
      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip id="admin-note-tooltip">{messages.adminNoteTooltip}</Tooltip>
        }
      >
        <OutlineInfoCircle16 className={"blue ml-1"} />
      </OverlayTrigger>
    </div>
    <div className={styles["admin-note"]}>{adminNote}</div>
  </div>
);

export default AdminNoteSessionDetilsSection;
